const MEASUREMENT_ID = 'G-R42KYKXDZD';

export function trackEvent(name, parameters) {
  try {
    if (typeof window.gtag === 'function') window.gtag('event', name, parameters);
  } catch {
    // Analytics must never prevent language selection or opening the store.
  }
}

export function initializeAnalytics() {
  if (typeof window === 'undefined' || window.__plannelyAnalyticsReady) return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, { page_path: window.location.pathname });
    const script = document.createElement('script');
    script.id = 'plannely-analytics';
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
    document.head.appendChild(script);
    window.__plannelyAnalyticsReady = true;
  } catch {
    // The landing remains usable with blocked analytics.
  }
}
